import React from 'react';
function LoadingContainer(_ref) {
  var _ref$state = _ref.state,
    state = _ref$state === void 0 ? false : _ref$state,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className;
  return React.createElement("div", {
    className: "loading-container ".concat(state ? 'd-flex' : 'd-none', " align-items-center justify-content-center ").concat(className)
  }, React.createElement("span", {
    className: "ecs-font-icon-act-loading"
  }));
}
export default LoadingContainer;